import type { ReactNode } from 'react';
import { clsx } from 'clsx';

/**
 * StatementBlock
 *
 * An emphasis / pull-quote block with a 4px left border in the brand orange.
 * Single-sided border, so no rounded corners on the bordered edge. Renders
 * larger, soft body text using design tokens only. No motion.
 */
export interface StatementBlockProps {
  /** The statement / pull-quote content. */
  children?: ReactNode;
  /** Optional additional classes merged onto the root element. */
  className?: string;
}

export function StatementBlock({ children, className }: StatementBlockProps) {
  return (
    <blockquote
      className={clsx(
        'rounded-none pl-5 sm:pl-6 py-1 text-lg sm:text-xl leading-relaxed',
        className,
      )}
      style={{
        borderLeft: '4px solid var(--orange)',
        color: 'var(--text)',
      }}
    >
      {children}
    </blockquote>
  );
}

export default StatementBlock;
